import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-vertical-floor-a-cabinet-features',
    templateUrl: './vertical-floor-a-cabinet-features.component.html',
    styleUrls: ['./vertical-floor-a-cabinet-features.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class VerticalFloorACabinetFeaturesComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  drainPanSelection!: GuruEntity;
  outsideAirWallBoxSelection!: GuruEntity;
  pipingControlsSelection!: GuruEntity;
  cabinetInsulationSelection!: GuruEntity;
  tamperProofPanelSelection!: GuruEntity;
  cabinetMaterialSelection!: GuruEntity;
  trimKitSelection!: GuruEntity;
  frontPanelInsulationSelection!: GuruEntity;
  levelingLegsSelection!: GuruEntity;
  rightExtensionSelection!: GuruEntity;
  leftExtensionSelection!: GuruEntity;
  extensionHeightSelection!: GuruEntity;
  extensionDepthSelection!: GuruEntity;
  insulatedRearExtensionSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.CABINET_FEATURES;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.drainPanSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USDrainPan');
    this.outsideAirWallBoxSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWallBox');
    this.pipingControlsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSameSidePipeControls');
    this.cabinetInsulationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabinetInsulation');
    this.tamperProofPanelSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USTamperProofPanel');
    this.cabinetMaterialSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USGSChassis');
    this.trimKitSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USTrimKit');
    this.frontPanelInsulationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRetBlkOff');
    this.levelingLegsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USLevelLegs');
    this.rightExtensionSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabExtRight');
    this.leftExtensionSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabExtLeft');
    this.extensionHeightSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabExtHeight');
    this.extensionDepthSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabExtDepth');
    this.insulatedRearExtensionSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USInsulatedAOR');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }


}
